import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
// import resourcesToBackend from 'i18next-resources-to-backend';
import { languageOptions, localStorageKey } from 'yankees-react-utils';

const configParams = {
    // debug: true, // enable for verbose messaging in console
    // lng: 'en', // force language if desired
    fallbackLng: 'en',
    preload: ['en'],
    supportedLngs: Object.keys(languageOptions),
    backend: {
        backends: [
            // resourcesToBackend((lng) => import(`../public/locales/${lng}-translation.json`)), // use for local load from file
            Backend,
            Backend,
        ],
        // DEVS: If you want to load db8 version all the time just reverse these two backend array items, but don't
        // check it in!
        backendOptions: [{
            loadPath: '/api/translation/portal/cdn/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer PLAYER_PORTAL_I18N', // this is an internal ID the API is looking for in order to let this request through
            },
        },
        {
            loadPath: '/api/translation/portal/local/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer PLAYER_PORTAL_I18N',
            },
        }],
    },
    detection: { // make sure the detection info matches the pattern used in react-utils config
        order: ['querystring', 'localStorage', 'sessionStorage', 'cookie', 'navigator', 'htmlTag'],
        lookupQuerystring: 'lng',
        lookupCookie: 'localeCookie',
        lookupLocalStorage: localStorageKey,
        lookupSessionStorage: localStorageKey,
        excludeCacheFor: ['cimode', ...Object.keys(languageOptions)],
    },
};

i18n
    .use(Backend)
    .use(Backend)
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .init(configParams);

// Events like these can be enabled as needed
// i18n.on('languageChanged', (lng) => {
//     console.log('lang changed-', lng);
// });

// i18n.on('initialized', (options) => {
//     console.log('init options-', options);
// });

export default i18n;
